/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 3/8/2022
 */
import BaseObject from "@shared/BaseObject.js";

export default class FeeItem extends BaseObject {
	amount: number = null
	description: string = null
	isDiscount: boolean = false

	getAmount(){
		return this.isDiscount ? -this.amount : this.amount
	}
}
